import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../_model/api-response';
import {
  CreateInstantTradeQuoteRequest,
  ExecuteInstantTradeRequest,
  HouseInstantTradeDto,
  HouseTradeQuoteDto
} from '../_model/house-trade';

@Injectable({ providedIn: 'root' })
export class HouseTradeService {
  private readonly base = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  createInstantQuote(payload: CreateInstantTradeQuoteRequest) {
    return this.http.post<ApiResponse<HouseTradeQuoteDto>>(
      `${this.base}/trades/instant-quotes`,
      payload
    );
  }

  getInstantQuote(quoteId: string) {
    return this.http.get<ApiResponse<HouseTradeQuoteDto>>(
      `${this.base}/trades/instant-quotes/${quoteId}`
    );
  }

  executeInstantTrade(payload: ExecuteInstantTradeRequest) {
    return this.http.post<ApiResponse<HouseInstantTradeDto>>(
      `${this.base}/trades/instant`,
      payload
    );
  }

  getInstantTrade(tradeId: string) {
    return this.http.get<ApiResponse<HouseInstantTradeDto>>(
      `${this.base}/trades/instant/${tradeId}`
    );
  }
}
